<template>
  <div class="modal with-outside">
    <div class="modal-outside modal-small" v-click-outside="closed">
      <div class="title">
        <h3>{{ iframe_item.Key }}</h3>
        <span class="diginity dg-close close" @click="closed"></span>
      </div>
      <div class="body-scroll">
        <div class="video-frame">
          <!-- is youtube -->
          <iframe v-if="iframe_item.Type.Value=='youtube'" width="720" height="480" :src="'https://www.youtube.com/embed/'+iframe_item.EmbedCode"
            frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
          <!--  is vimeo -->
          <iframe v-else width="720" height="480" :src="'http://player.vimeo.com/video/'+iframe_item.EmbedCode+'?&title=0&byline=0&portrait=0&wmode=opaque'"
            frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  methods: {
    closed() {
      this.$router.push(`/${this.lng}/videos/${this.$route.params.type}`);
    }
  },
  computed: {
    ...mapGetters(['lng', 'videos_list']),
    iframe_item() {
      return this.videos_list.find(item => {
        return this.$route.params.id == item.ID;
      });
    }
  }
};
</script>

<style lang="scss">
@import '../../styles/colors';
</style>
